import React from 'react';

import { Rect } from 'react-konva';

export default function CanvasRect(props) {
  return (
    <Rect ref={props.innerRef} shadowForStrokeEnabled={false} perfectDrawingEnabled={false} {...props}/>
  );
}
